import React, { memo } from 'react'
import { Grid } from '@mui/material'
import { faPlus } from '@fortawesome/free-solid-svg-icons'
import { Link } from 'react-router-dom'

import PageContainer from '../shared/PageContainer/PageContainer'
import DisplayAlerts from '../setup/common/DisplayAlerts'
import BaseCard from '../shared/BaseCard/BaseCard'
import PanelHeading from '../shared/PanelHeading/PanelHeading'
import CustomButton from '../shared/buttons/CustomButton'
import FaIcon from '../shared/FaIcon/FaIcon'
import { LABEL_TEXT } from '../../constants/messages'
import Dropdown from '../shared/inputs/Dropdown'
import { CAMPAIGN_LIST_PROFILE_DISPATCH } from '../../store/reducers/campaign/campaignList'
import CardGrid from '../shared/containers/CardGrid'
import ButtonsGroup from '../shared/buttons/ButtonsGroup'
import { buildCampaignStatusOptions } from '../../util/campaign.helpers'
import CampaignsData from './CampaignsData'
import SetupRequiredAction from '../shared/Dashboard/SetupRequiredAction'
import DefaultText from '../shared/text/DefaultText'
import { SETUP_URL } from '../../constants/navigation'

const Campaigns = ({
  isDashboardSetupReady,
  tokenProfile,
  onCreateNew,
  dispatchAction,
  campaignListProfile,
  campaignTableProps,
  isFullIntegration,
  t
}) => {
  const title = t('campaign.campaigns-management')
  const { status, selected, isListUpdate } = campaignListProfile
  return (
    <PageContainer title={title}>
      <DisplayAlerts
        isDashboardSetupReady={isDashboardSetupReady}
        tokenStatus={tokenProfile.status}
        t={t}
      />
      <CardGrid>
        <Grid item xs={12}>
          <BaseCard>
            <PanelHeading title={title}>
              {!isDashboardSetupReady ? (
                <SetupRequiredAction
                  description={t('common.not-completed-setup')}
                  t={t}
                  action={
                    <Link to={SETUP_URL}>
                      <CustomButton
                        fullWidth={false}
                        label={t('developers.start-setup')}
                      />
                    </Link>
                  }
                />
              ) : isFullIntegration ? (
                <>
                  <DefaultText
                    label={t('campaign.campaigns-management-desc', {
                      symbol: tokenProfile.symbol
                    })}
                  />
                  <Grid
                    container
                    sx={{ display: 'flex', alignItems: 'flex-end' }}
                  >
                    <Grid item xs={12} md={6} sx={{ display: 'flex' }}>
                      <Grid item xs={12} md={4} sx={{ pr: 2 }}>
                        <Dropdown
                          id={CAMPAIGN_LIST_PROFILE_DISPATCH.STATUS}
                          label={t(LABEL_TEXT.STATUS)}
                          options={buildCampaignStatusOptions(t)}
                          onChange={({ target }) =>
                            dispatchAction(
                              CAMPAIGN_LIST_PROFILE_DISPATCH.STATUS,
                              target.value
                            )
                          }
                          value={status}
                          size='small'
                        />
                      </Grid>
                    </Grid>
                    <Grid item xs={12} md={6}>
                      <ButtonsGroup>
                        <CustomButton
                          fullWidth={false}
                          label={t('campaign.create-new-campaign')}
                          startIcon={<FaIcon icon={faPlus} />}
                          onClick={onCreateNew}
                        />
                      </ButtonsGroup>
                    </Grid>
                  </Grid>
                </>
              ) : (
                <DefaultText
                  label={t('analytics.not-accessible-to-light-integrations')}
                />
              )}
            </PanelHeading>
          </BaseCard>
        </Grid>
        {isDashboardSetupReady && isFullIntegration && (
          <Grid item xs={12}>
            <CampaignsData
              t={t}
              tokenProfile={tokenProfile}
              selected={selected}
              isListUpdate={isListUpdate}
              campaignListProfile={campaignListProfile}
              {...campaignTableProps}
            />
          </Grid>
        )}
      </CardGrid>
    </PageContainer>
  )
}

export default memo(Campaigns)
